import { Box, Skeleton, Card, CardContent, Paper, Grid, LinearProgress } from '@mui/material';
import { IbssComponent } from '../../../../Components/Core/BaseComponent/IbssComponent';

class EventDetailsSkeleton extends IbssComponent<IState,IProps>
{
    public render(): JSX.Element
    {
        return (
            <Box className="page-height-exct-header">
                <Box className="rightPanel-main-content">
                    <Box position={"relative"}>
                        <Box position={"relative"}>
                            {/* Hero Banner Skeleton */}
                            <Skeleton variant="rectangular" className="flex-home-bg" height={300} />
                            <Skeleton
                                variant="circular"
                                sx={{
                                    position: 'absolute',
                                    width: '320px',
                                    height: '320px',
                                    top: 30,
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    borderRadius: 2,
                                    boxShadow: 3,
                                }}
                            />
                        </Box>
                        <Grid container spacing={4} position={'relative'} top={252}>
                            {/* Left Section Skeleton */}
                            <Grid item xs={12} md={8} zIndex={'11'}>
                                <Paper sx={{ p: 4 }}>
                                    <Box display={'flex'} justifyContent={'space-between'} mb={2}>
                                        <Box>
                                            <Skeleton variant="text" width="50%" height={40} />
                                            <Skeleton variant="text" width="80%" height={20} />
                                        </Box>
                                        <Skeleton variant="rounded" width={100} height={30} />
                                    </Box>
                                    <Box display={'flex'} gap={2} my={4}>
                                        <Box display={'flex'} gap={1} mb={1}>
                                            <Skeleton variant="circular" width={24} height={24} />
                                            <Skeleton variant="text" width="50%" height={20} />
                                        </Box>
                                        <Box display={'flex'} gap={1} mb={1}>
                                            <Skeleton variant="circular" width={24} height={24} />
                                            <Skeleton variant="text" width="50%" height={20} />
                                        </Box>
                                        <Box display={'flex'} gap={1}>
                                            <Skeleton variant="circular" width={24} height={24} />
                                            <Skeleton variant="text" width="50%" height={20} />
                                        </Box>
                                    </Box>
                                    <Skeleton variant="rectangular" width="100%" height={100} />
                                    <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                                        <Skeleton variant="rounded" width={150} height={40} />
                                        <Skeleton variant="rounded" width={150} height={40} />
                                    </Box>
                                </Paper>
                            </Grid>

                            {/* Right Section Skeleton */}
                            <Grid item xs={12} md={4} zIndex={'11'}>
                                <Card sx={{ p: 2 }}>
                                    <CardContent>
                                        <Skeleton variant="text" width="60%" height={30} />
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
                                            <Skeleton variant="text" width="70%" />
                                            <Skeleton variant="text" width="30%" />
                                        </Box>
                                        <LinearProgress sx={{ mt: 1, height: 10 }} />
                                        <Skeleton variant="text" width="100%" sx={{ mt: 2 }} />
                                        <Skeleton variant="rounded" width="100%" height={40} sx={{ mt: 2 }} />
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Box>
        );
    }
}

export default EventDetailsSkeleton;

interface IState
{
}

interface IProps
{
}